import { Component, inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { UiStore } from '../../../stores/ui.store';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './toast.component.html',
  animations: [
    trigger('toastFade', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(0.5rem)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(0.5rem)' })),
      ]),
    ]),
  ],
})
export class ToastComponent {
  protected readonly uiStore = inject(UiStore);
}
